module.exports = __webpack_public_path__ + "img/TOP2.26f45b22.png";